export const translation = {
  logout: 'Logout',
  userSettings: 'View my account',
  admin: 'Admin',
  notConnected: 'Not connected',
  otherLanguage: 'Français',
  tabTitle: 'PMP Solutions portal',
  buttons: {
    cancel: 'Cancel',
    submit: 'Submit',
    retry: 'Retry',
  },
  errors: {
    loadingError: 'An error occurred while loading data.',
  },
  reports: {
    loading: 'Loading...',
    errorLoading: 'Error loading reports',
    pleaseSelectAReport: 'Please select a report to display.',
    reportListTitle: 'Reports',
    analyticsTitle: 'Analytics',
    favoritesTitle: 'Favorites',
    noReportSelected: 'No report selected',
    refreshingReport: 'Refreshing report...',
    refreshReportFailed: 'We could not refresh this report. Please reload the page.',
  },
  help: {
    myOrganization: 'My organization',
    needHelp: 'Need help?',
    helpCenter: 'Help center',
    supportRequests: 'Support / Requests',
    bookMeeting: 'Book a meeting',
    email: 'Email us',
    visit: 'Visit pmpsolutions.ca',
    noSites: "You don't have any assigned site",
  },
  home: {
    welcome: 'Welcome, {{name}} !',
    description:
      'Welcome to PMP TeamMate. Monitor your sawmill operations with real-time dashboards and comprehensive reports across all your products.',
    selectFromSidebar: 'Select a product or report from the sidebar to get started or download our desktop app.',
    restartOnboarding: 'Start the onboarding tutorial',
    restartOnboardingAction: 'Start',
  },
  downloadApp: {
    title: 'Desktop App',
    homeTitle: 'Download PMP TeamMate Desktop App',
    downloadButton: 'Download PMP TeamMate',
    description: 'Access additional features and tools with our desktop application',
    requiresConnection: 'Requires connection to mill network',
  },
  supportForm: {
    name: 'Name',
    email: 'Email',
    millName: 'Mill Name',
    phone: 'Telephone',
    addFiles: 'Add Files',
    title: 'Title',
    details: 'Describe your problem. Add details so we can help you more efficiently.',
    description: 'Description',
    descriptionRequired: 'Description is required',
    errorMessage: 'An error occurred while submitting the ticket.',
  },
  dashboards: {
    refreshEvery5Minutes:
      "You must be connected to the mill's local network to access the real-time dashboards. The previews are refreshed every 15 minutes.",
    dashboards: 'Dashboards',
    openLiveDashboard: 'Open live dashboard',
    live: {
      loading: 'Connecting…',
      online: 'Live',
      offline: 'Offline',
      offlineSince: 'Offline since {{time}}',
      unavailable: 'Unavailable',
      openInNewTab: 'Open in a new tab',
      notFound: 'This dashboard is not available on this site.',
    },
  },
  products: {
    myProducts: 'My products',
    otherProducts: 'Other products',
    inConstruction: 'This page is under construction',
  },
  resourceReports: {
    reports: 'Reports (pdf)',
    selectEquipment: 'Select Equipment',
    browseAllReports: 'Browse all available reports',
    shift: 'Shift:',
    day: 'Day:',
    current: 'Current',
    last: 'Last',
    today: 'Today',
    week: 'Week:',
    month: 'Month:',
    year: 'Year:',
    yesterday: 'Yesterday',
    currentFiscal: 'Current Fiscal',
    lastFiscal: 'Last Fiscal',
    fiscal: 'Fiscal',
    unavailable: 'Report unavailable',
  },
  tools: {
    tools: 'Tools',
    downtimeDocumentation: 'Downtime documentation',
    editGaugeLimits: 'Edit operational limits',
    reportsPortal: 'Reports Portal',
  },

  connection: {
    dashboardAndToolsNotAvailable:
      'Live dashboards and tools are only available when you are connected to your mill network',
    documentationToolNotAvailable:
      'Downtime documentation is only available when you are connected to your mill network',
  },
  migration: {
    title: 'Action Required',
    description: 'You must reset your password to continue accessing the portal.',
    securityNote: 'This update strengthens platform security and aligns it with current best practices.',
    securityNotePart1: 'This is a preventive measure and ',
    securityNoteBold: 'not related to a security incident.',
    requirementsPart1: 'This step is required for ',
    requirementsPart2Bold: 'all users',
    requirementsPart3: '. Your previous password will no longer work.',
    procedureTitle: 'How to proceed:',
    step1Part1: 'Click ',
    step1Bold: '"Proceed to Login"',
    step2Part1: 'Enter your email and click ',
    step2Bold: '"Next"',
    step3Part1: 'Click ',
    step3Bold: '"Forgot password?"',
    step4: 'Follow the steps to create your new password',
    supportPart1: 'Need help? ',
    supportLink: 'Contact our support team',
    supportPart2: '.',
    proceedToLoginButton: 'Proceed to Login',
  },
  bootstrapError: {
    title: 'Site temporarily unavailable',
    description:
      'The portal is being updated to support multiple sites. Thank you for your patience during this transition.',
    firstLogin: 'Please try again in a few moments by clicking the "Try Again" button to gain access.',
    contact: 'If the problem persists, please contact support:',
    retry: 'Try Again',
    backToLogin: 'Back to Login',
  },
  userSettingsPage: {
    title: 'My account',
    phoneNumber: 'Phone Number:',
    organizationName: 'Organization Name:',
    email: 'Email:',
    name: 'User Name:',
    firstName: 'First Name',
    lastName: 'Last Name',
    changePassword: 'Change your password', // NOSONAR
    here: 'here',
    save: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    failSave: 'Failed to save details',
    successSave: 'Details saved successfully',
    invalidName: 'Invalid name',
    invalidFirstName: 'Invalid first name',
    invalidLastName: 'Invalid last name',
    invalidPhone: 'Invalid phone number',
    profileSection: 'Profile Information',
    securitySection: 'Security Settings',
  },
  adminPage: {
    title: 'Admin Dashboard',
    PowerBIReports: 'Power BI Reports',
  },
  updateAlert: {
    newVersion: 'A new version of the application is available. The page will refresh in ',
    seconds: ' seconds.',
    now: 'Refresh now',
  },
  qualityControl: {
    back: 'Back',
    editTest: 'Edit Test',
    scheduleActivation: 'Schedule Activation',
    saveAndActivate: 'Save & Activate',
    pendingVersionBanner:
      'You are editing version {{version}}, activating on {{date}}. Reminder: edited definition fields display immediately; only version changes are deferred.',
    definitionTab: 'Definition',
    formSchemaTab: 'Form Schema',
    scoreParametersTab: 'Score Parameters',
    displayName: 'Display Name',
    category: 'Category',
    description: 'Description',
    displayOrder: 'Display Order',
    scoreCalculatorType: 'Score Calculator Type',
    canTestMultipleEntities: 'Can Test Multiple Entities',
    targetTestsPerShift: 'Tests Per Shift Target',
    scheduledActivationDate: 'Scheduled Activation Date',
    schedulingHelper: 'Scheduling is available once the test is active.',
    schedulingActiveHelper:
      'Applies to form and score parameters only — test identity fields are always saved immediately.',
    scheduledDateInPastError: 'Scheduled activation date must be in the future.',
    testIdentitySection: 'Test Identity',
    testIdentitySectionHelper: 'Always saved immediately, regardless of scheduling.',
    versionContentSection: 'Version Content',
    formJsonLabel: 'Form JSON (SurveyJS)',
    mustBeValidJson: 'Must be valid JSON — validated on save.',
    addParameter: '+ Add Parameter',
    saveErrorDefault: 'An error occurred while saving the test definition.',
    version: 'v',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    openSurveyJSCreator: 'Open SurveyJS Creator',
    error: 'Error',
    warning: 'Warning',
    success: 'Success',
    info: 'Info',
    testEditorTitle: 'Test Editor',
    testEditorSubtitle: 'Edit the details of your quality control test.',
    testEditorTabs: 'Test Editor Tabs',
    testEditorForm: 'Test Editor Form',
    testEditorScore: 'Test Editor Score',
    testEditorParameters: 'Test Editor Parameters',
    testEditorSave: 'Save Test',
    testEditorCancel: 'Cancel',
    testEditorBack: 'Back',
    testEditorPending: 'Pending',
    testEditorActive: 'Active',
    testEditorInactive: 'Inactive',
    testEditorScheduled: 'Scheduled',
    testEditorVersion: 'Version',
    testEditorActivation: 'Activation',
    testEditorExecutions: 'Executions',
    testEditorHistory: 'History',
    testEditorDefinition: 'Definition',
    testEditorFormSchema: 'Form Schema',
    testEditorScoreParameters: 'Score Parameters',
    testEditorAddParameter: '+ Add Parameter',
    testEditorMustBeValidJson: 'Must be valid JSON — validated on save.',
    testEditorSchedulingHelper: 'Scheduling is only available once this test has existing executions',
    testEditorSaveErrorDefault: 'An error occurred while saving the test definition.',
    testEditorOpenSurveyJSCreator: 'Open SurveyJS Creator Demo',
    averageScoreTooltip: 'Average score for past 30 days',
    menuTitle: 'Quality Control',
    title: 'Quality Control Tests',
    noTests: 'No quality control tests available',
    viewForm: 'View Form',
    backToList: 'Back to Test List',
    lastUpdated: 'Version Date',
    errorLoading: 'Error loading quality control tests',
    uncategorized: 'Uncategorized',
    executeTest: 'New Test',
    viewHistory: 'History',
    averageScore: 'Average Score',
    executionCount: 'Executions',
    observedBy: 'Observed By',
    versionNumber: 'Version',
    submitting: 'Submitting...',
    submitSuccess: 'Test submitted successfully. Redirecting...',
    submitError: 'An error occurred while submitting. Please try again.',
    retry: 'Retry',
    history: 'Execution History',
    noHistory: 'No executions recorded yet.',
    backToHistory: 'Back to History',
    executionDate: 'Date',
    observedAt: 'Observed At',
    score: 'Score',
    comments: 'Comments',
    penalty: 'Penalty',
    penaltyPerUnit: 'Penalty/Step',
    maxPenalty: 'Max Penalty',
    noParameters: 'No parameters defined',
    type: 'Type',
    fieldName: 'Field Name',
    matrixField: 'Matrix Field',
    actions: 'Actions',
    step: 'Step',
    addOption: 'Add Option',
    recomputeAllScores: 'Recompute All Scores',
    recomputingScores: 'Recomputing...',
    recomputeSuccess: 'Recomputed {{count}} execution(s) successfully',
    recomputeError: 'An error occurred while recomputing scores.',
    createTest: 'Create New Test',
    adminTools: 'Admin Tools',
    scoreParametersDisabledTooltip: 'Save the test first to configure score parameters',
    testCreatedSuccess: 'Test created successfully',
    recomputeConfirmTitle: 'Recompute All Scores?',
    recomputeConfirmBody: 'This will recompute scores for all test executions. This may take a while.',
    print: 'Print',
    correct: 'Correct',
    correctionBadge: 'Correction',
    deleted: 'Deleted',
    deleteExecution: 'Delete',
    deleting: 'Deleting...',
    deleteExecutionConfirmTitle: 'Delete this execution?',
    deleteExecutionConfirmBody:
      'This execution will be marked as deleted. It will remain visible in history but excluded from scores. Admins can restore it.',
    deleteExecutionSuccess: 'Execution deleted successfully',
    deleteExecutionError: 'An error occurred while deleting the execution.',
    restoreExecution: 'Restore',
    restoring: 'Restoring...',
    restoreExecutionConfirmTitle: 'Restore this execution?',
    restoreExecutionConfirmBody: 'This execution will be restored and included in score calculations again.',
    restoreExecutionSuccess: 'Execution restored successfully',
    restoreExecutionError: 'An error occurred while restoring the execution.',
    deletedExecutionsInRange: '{{count}} deleted execution(s) in the score window',
  },
  onboarding: {
    welcome: {
      title: 'Welcome!',
      description:
        'Welcome to the PMP Portal, which is now multi-site! Here are your available sites, each one gives you access to the tools, reports, and dashboards of the selected mill.',
    },
    hub: {
      title: 'Your Sites',
      description: 'Click on a site to open it. The site you select will open automatically the next time you log in.',
    },
    helpButton: {
      title: 'Help Center',
      description: " The help center has moved here. We've refreshed its content to better support you.",
    },
    helpMenu: {
      title: 'Support Requests',
      description:
        'The help request form is available inside this menu. This is your go-to place to reach our support team.',
    },
    breadcrumb: {
      title: 'Navigation Path',
      description: 'This path shows you where you are in the portal.',
    },
    breadcrumbSite: {
      title: 'Site Selection',
      description:
        'You can see your current site here. If you have multiple sites, use this menu to switch between them at any time.',
    },
    sideBar: {
      title: 'Products and Tools',
      description: "The sidebar gives you access to all of your site's products and available tools.",
    },
    sideBarButton: {
      title: 'Sidebar Display',
      description: 'You can open and close the sidebar whenever you like.',
    },
    productSection: {
      title: 'Your Products',
      description:
        'The sidebar will close automatically, giving you more screen space. You may still use the sidebar icons to switch between products or tools.',
    },
    breadecrumbProduct: {
      title: 'Product Selection',
      description:
        "The path displays the currently selected product. If you have multiple products, it's also a quick way to switch without going back to the sidebar.",
    },
    dashboardsNavigation: {
      title: 'Dashboards',
      description:
        "Use the arrows to browse the dashboards previews. You must be connected to the mill's local network to see them in real-time.",
    },
    documentationButton: {
      title: 'Downtimes',
      description: "Access your downtime documentation here. You must be connected to the mill's local network.",
    },
    reportsSection: {
      title: 'Production Reports',
      description:
        'This button opens the reports portal. The links above offer a small selection of the reports available in the portal.',
    },
    homeButton: {
      title: 'Back to the Home Page',
      description: 'You can return to the home page at any time by clicking this button.',
    },
  },
}
